export default "__VITE_ASSET__0fbb0409__"